import styled from 'styled-components'

export const Outer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: #6B71C2;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 1px 10px rgb(0,0,0,0.1);
    width: calc(100vw - 30px);
`;

export const Left = styled.div`
    display: flex;
    align-items: center;

    a {
        text-decoration: none;
        color: #FFFFFF;
        margin-right: 20px;
        font-size: 18px;
    }
`;

export const Title = styled.div`
    color: #FFFFFF;
    font-weight: 700;
    font-size: 18px;
    margin: 0px 20px;
    cursor: pointer;
`;

export const Icon = styled.img`
    width: 32px;
    height: 32px;
    cursor: pointer;
`;

export const Lower = styled.div`
    width: 100%;
    height: 41px;
    position: fixed;
    top: 62px;
    left: 0;
    display: flex;
    justify-content: center;
    box-shadow: 0px 1px 10px rgb(0,0,0,0.1);
`;

export const Page = styled.div`
        background: ${props => props.selected ? '#efefef':'#FFFFFF'};
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0px;
        border-bottom: 1px solid #c1bcbc;

        :first-child {
            border-right: 1px solid #c1bcbc;
        }

        a {
            text-decoration: none;
            color: #333333;
        }
`;